<template>
    <div class="filter">
        <div v-clickaway="closeFilter" class="filter__button">
            <div :class="filterClass" @click="toggleFilter">
                <span v-if="showLabelFirst">{{ displayLabel }}</span>
                <common-icon name="filter" size="medium"></common-icon>
                <span v-if="!showLabelFirst">{{ displayLabel }}</span>
            </div>

            <common-dropdown
                v-show="isFilterOpen"
                class="filter__dropdown"
                :hasArrow="false"
                arrowPositionX="top"
                arrowPositionY="right"
            >
                <common-content-spacer height="medium">
                    <div v-if="title" class="filter__dropdown-title">
                        {{ title }}
                    </div>
                    <form-wrapper @submit="applyFilter">
                        <common-content-spacer height="medium">
                            <div>
                                <form-row v-for="(option, index) of filterOptions" :key="index">
                                    <form-cell>
                                        <checkbox-input
                                            :label="option.label"
                                            :value="option.value"
                                            :class="option.class"
                                            @change.native="filterChange(option)"
                                        ></checkbox-input>
                                    </form-cell>
                                </form-row>
                            </div>
                            <common-buttons>
                                <common-button
                                    :isDisabled="allOptionsUnchecked"
                                    :label="confirmButtonDisplayLabel"
                                    :isFluid="true"
                                    size="medium-small"
                                    type="secondary"
                                ></common-button>
                            </common-buttons>
                        </common-content-spacer>
                    </form-wrapper>
                </common-content-spacer>
            </common-dropdown>
        </div>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'

    export default {
        mixins: [FormMixin],

        props: {
            title: { type: String, default: '' },
            options: { type: Array, required: true },
            label: { type: String, default: null },
            confirmButtonLabel: { type: String, default: null },
            showLabelFirst: { type: Boolean, default: false },
        },

        data() {
            return {
                isFilterOpen: false,
                filterOptions: [],
            }
        },

        computed: {
            displayLabel() {
                return this.label || this.$t('common.microcopy.filters')
            },
            confirmButtonDisplayLabel() {
                return this.confirmButtonLabel || this.$t('common.microcopy.update_list')
            },
            filterClass() {
                return {
                    filter__blured: this.isFilterOpen,
                }
            },

            allOptionsUnchecked() {
                return this.filterOptions.every((option) => !option.value)
            },
        },

        methods: {
            toggleFilter() {
                this.isFilterOpen = !this.isFilterOpen
            },

            closeFilter() {
                this.isFilterOpen = false
            },

            filterChange(option) {
                const filterOption = this.filterOptions.find((o) => o.label === option.label)
                filterOption.value = !option.value
            },

            applyFilter() {
                this.$emit('filter-changed', this.filterOptions)
                this.closeFilter()
            },
        },

        watch: {
            options() {
                this.filterOptions = this.options
            },
        },

        mounted() {
            this.filterOptions = this.options
        },
    }
</script>
